import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Grid,
  Paper,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { forgotPasswordSuccess, setLoading } from '../../features/authSlice';
import CarouselComponent from '../../common/components/CarouselComponent';
import ForgotPasswordForm from './ForgotPasswordForm';
import CommonButton from '../../common/components/CommonButton';
import CommonDialog from '../../common/components/CommonDialog';
import { forgotPassword } from '../../api/authApi';
import LoadingSpinner from '../../common/components/LoadingSpinner';
import { showNotification } from '../../common/components/Notification/ToastifyNotification';

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = useState(false);
  const { loading } = useSelector((state) => state.auth);

  const handleSubmit = async (values) => {
    try {
      dispatch(setLoading({
        loading: true
      }));
      const response = await forgotPassword(values);
      if (response.message === 'User does not found using email') {
        showNotification(response.message, 'error');
        dispatch(setLoading({
          loading: false
        }));
      } else {
        dispatch(forgotPasswordSuccess({
          message: response.message
        }));
        setOpen(true);
      }
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.response?.data.err;
      showNotification(errorMessage, 'error');
      dispatch(setLoading({
        loading: false
      }));
    }
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      {loading && (
        <LoadingSpinner />
      )}
      <CommonDialog
        open={open}
        size="xs"
        content={(
          <center>
            <img
              src='/Images/checkcircleorange.png'
              alt='Check Circle'
              style={{ width: '70px', height: '70px' }}
            />
            <Typography sx={{ fontWeight: 600, fontSize: '22px', mt: 0.5 }}>
              Reset password link successfully sent in mail.
            </Typography>
          </center>
        )}
        actionButtons={(
          <CommonButton
            label="Ok"
            size="large"
            handleClick={() => {
              if (location.search.split('=')[1] === 'hub') {
                navigate('/mentor');
              } else {
                navigate('/login');
              }
              setOpen(false);
            }}
          />
        )}
      />
      <Paper
        elevation={isMobile ? 0 : 3}
        sx={{
          width: '100%',
          height: '100%',
          borderRadius: 0,
          overflow: 'hidden',
        }}
      >
        <Grid container sx={{ height: '100%' }}>
          <Grid
            item
            xs={12}
            md={6.5}
            sx={{
              height: '100%',
              overflow: 'hidden',
              display: { xs: isMobile ? 'none' : 'flex', md: 'flex' },
            }}
          >
            <CarouselComponent />
          </Grid>
          <Grid
            item
            xs={12}
            md={5.5}
            sx={{
              height: '100%',
              overflowY: 'auto',
              display: 'flex',
              backgroundColor: 'white',
            }}
          >
            <ForgotPasswordForm
              onSubmit={handleSubmit}
              loading={loading}
            />
          </Grid>
        </Grid>
        {isMobile && (
          <Box sx={{ height: '100%', overflowY: 'auto' }}>
            <ForgotPasswordForm
              onSubmit={handleSubmit}
              loading={loading}
            />
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default ForgotPassword;